export const valueLabels = [
    'Unranked',
    'Lowest',
    'Signifcantly Below Average',
    'Clearly Below Average',
    'Below Average',
    'Average',
    'Above Average',
    'Clearly Above Average',
    'Signifcantly Above Average',
    'Near Highest',
    'Highest'
];

export const marks = [
    { value: 0, label: '0' },
    { value: 10 },
    { value: 20 },
    { value: 30 },
    { value: 40 },
    { value: 50 },
    { value: 60 },
    { value: 70 },
    { value: 80 },
    { value: 90 },
    { value: 100, label: '10' },
];